import { LogOut, User } from "lucide-react";
import { Button } from "../Button";
import { useStore } from "../../store";
import { useAuth } from "../../hook/auth";
import { useNavigate } from "react-router-dom";

export interface ProfileProps {}

export function Profile() {
  const user = useStore((store) => store.user);
  const { signOut } = useAuth();
  const navigate = useNavigate();

  function handleSignOut() {
    signOut();
    navigate("/");
  }
  return (
    <div className="flex items-center gap-3 rounded-xl bg-white/[0.04] p-2.5 ring-1 ring-white/[0.06]">
      <button
        type="button"
        onClick={() => navigate("/perfil")}
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-white/15 to-white/5 text-white ring-1 ring-white/10 transition hover:from-white/20 hover:to-white/10"
        title="Ver perfil"
      >
        <User className="h-5 w-5 text-zinc-200" />
      </button>

      <div className="min-w-0 flex-1">
        <button
          type="button"
          onClick={() => navigate("/perfil")}
          className="w-full text-left transition-opacity hover:opacity-90"
        >
          <span className="block truncate text-sm font-semibold text-white">
            {user?.name}
          </span>
          <span className="block truncate text-xs text-zinc-400">
            {user.email}
          </span>
        </button>
      </div>
      <Button
        variant="ghost"
        className="shrink-0 text-zinc-300 hover:bg-white/10 hover:text-white focus-visible:ring-white/30"
        onClick={handleSignOut}
        title="Sair"
      >
        <LogOut className="h-5 w-5" />
      </Button>
    </div>
  );
}
